import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-polygon",
  "use": "icon-polygon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-polygon\"><path d=\"M709.76 848.32H314.24a24 24 0 0 1-22.8-16.56L169.2 455.6c-3.2-9.92 0.32-20.72 8.72-26.8l320-232.48c8.4-6.08 19.84-6.08 28.24 0l320 232.48a24 24 0 0 1 8.72 26.8l-122.24 376.16a24.064 24.064 0 0 1-22.88 16.56z m-378.08-48h360.64l111.44-343.04L512 245.36l-291.76 212 111.44 342.96z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol